import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useThemeStore } from '../../store/themeStore';

export const ThemeToggle: React.FC = () => {
  const { theme, isDark, setTheme } = useThemeStore();
  const [isOpen, setIsOpen] = React.useState(false);

  const themes = [
    { value: 'light', icon: Sun, label: 'Clair' },
    { value: 'dark', icon: Moon, label: 'Sombre' },
    { value: 'system', icon: Monitor, label: 'Système' }
  ];

  return (
    <div className="relative">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200 hover:scale-110"
      >
        {isDark ? (
          <Moon className="w-5 h-5 animate-pulse" />
        ) : (
          <Sun className="w-5 h-5 animate-pulse" />
        )}
      </button>

      {/* Dropdown */}
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute right-0 mt-2 w-40 bg-white/95 dark:bg-gray-800/95 backdrop-blur-md rounded-xl shadow-xl border border-gray-200 dark:border-gray-700 z-50 animate-scale-in">
        <div className="py-1">
          {themes.map(({ value, icon: Icon, label }) => (
            <button
              key={value}
              onClick={() => {
                setTheme(value as any);
                setIsOpen(false);
              }}
              className={`flex items-center space-x-2 w-full px-3 py-2 text-sm transition-colors ${
                theme === value
                  ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 font-medium'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:translate-x-1'
              }`}
            >
              <Icon className={`w-4 h-4 ${theme === value ? 'animate-bounce-subtle' : ''}`} />
              <span>{label}</span>
            </button>
          ))}
        </div>
          </div>
        </>
      )}
    </div>
  );
};